module.exports = __webpack_public_path__ + "static/media/vocab.aaa9a8c7.png";